import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createElementVNode as _createElementVNode, withCtx as _withCtx, createSlots as _createSlots } from "vue"

const _hoisted_1 = ["title"]
const _hoisted_2 = {
  key: 0,
  class: "conversation__subname-actor"
}
const _hoisted_3 = { class: "conversation__subname-message" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ConversationIcon = _resolveComponent("ConversationIcon")
  const _component_NcListItem = _resolveComponent("NcListItem")

  return (_openBlock(), _createBlock(_component_NcListItem, {
    name: $props.item.displayName,
    title: $props.item.displayName,
    active: $props.item.token === $setup.selectedRoom?.token,
    bold: $setup.exposeMessagesRef && !!$props.item.unreadMessages,
    "counter-number": $setup.exposeMessagesRef ? $props.item.unreadMessages : 0,
    "counter-type": $setup.counterType,
    onClick: $options.onClick
  }, _createSlots({
    icon: _withCtx(() => [
      (_openBlock(), _createBlock(_component_ConversationIcon, {
        key: $props.item.token,
        item: $props.item,
        "hide-favorite": !$props.item?.attendeeId,
        "hide-call": !$props.item?.attendeeId
      }, null, 8, ["item", "hide-favorite", "hide-call"]))
    ]),
    _: 2
  }, [
    ($setup.conversationInformation.message)
      ? {
          name: "subname",
          fn: _withCtx(() => [
            _createElementVNode("span", {
              class: "conversation__subname",
              title: $setup.conversationInformation.title
            }, [
              ($setup.conversationInformation.actor)
                ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString($setup.conversationInformation.actor), 1))
                : _createCommentVNode("", true),
              ($setup.conversationInformation.icon)
                ? (_openBlock(), _createBlock(_resolveDynamicComponent($setup.conversationInformation.icon), {
                    key: 1,
                    class: "conversation__subname-icon",
                    size: 16
                  }))
                : _createCommentVNode("", true),
              _createElementVNode("span", _hoisted_3, _toDisplayString($setup.conversationInformation.message), 1)
            ], 8, _hoisted_1)
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["name", "title", "active", "bold", "counter-number", "counter-type", "onClick"]))
}